/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OpenGoal Platform API
 * Agency-facing API — day-to-day platform usage by agency users.
 * OpenAPI spec version: 1.0
 */

export type IncentiveMetric = typeof IncentiveMetric[keyof typeof IncentiveMetric];


export const IncentiveMetric = {
  appearance: 'appearance',
  goal: 'goal',
  assist: 'assist',
  clean_sheet: 'clean_sheet',
  trophy: 'trophy',
  loyalty: 'loyalty',
  signing_on: 'signing_on',
  team_performance: 'team_performance',
} as const;
